import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";

export default class GameDataParser
    implements IBaseDataParser<IAuthorizationData>
{
    check(data: any): boolean {
        return data?.data?.gameData?.lineLayout;
    }

    parse(data): IAuthorizationData[] {
        let numberOfReels = data.data.gameData.reelToViewMap.length;

        let waysGame =
            !data.data.gameData.lineLayout ||
            data.data.gameData.lineLayout.length == 0;

        let lines = waysGame
            ? []
            : Array.from(
                  new Array(data.data.gameData.lineLayout.length),
                  (line, lineId) => {
                      return Array.from(
                          new Array(numberOfReels),
                          (reel, rowId) => {
                              return Math.floor(
                                  (data.data.gameData.lineLayout[lineId][
                                      rowId
                                  ] -
                                      1) /
                                      numberOfReels
                              );
                          }
                      );
                  }
              );

        const result = {
            playerConfig: {
                userId: data.data.userId,
                isDemoPlayer: true, // TODO
                currency: "", //TODO MAYBE THERE IS SOME MAPPING
            },
            serverGameConfig: {
                paylines: lines,
                reelToViewMap: data.data.gameData.reelToViewMap,
                paytable: data.data.gameData.payTable,
                layout: data.data.gameData.reelToViewMap, //TODO
                waysGame: waysGame,
                defaultStopPositions: data.data.gameData.reelStops,
                rtp: data.data.gameData.gameRTP,
                scatterReels: GameModel.gameConfig.scatterReels,
                freeSpinSymbol: data.data.gameData.freeSpinSymbol
            },
        };

        return [result];
    }
}
